import { ChangeDetectionStrategy, Component, OnDestroy, inject, signal } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import {
  DsAlertComponent,
  DsAnswerOptionComponent,
  DsAssessmentHistoryComponent,
  DsAssessmentHistoryItem,
  DsAssessmentInstructionsComponent,
  DsAssessmentProgressComponent,
  DsAssessmentTimerComponent,
  DsBadgeComponent,
  DsButtonDirective,
  DsCardComponent,
  DsCheckboxDirective,
  DsFieldComponent,
  DsInputDirective,
  DsQuestionCardComponent,
  DsQuestionNavigatorComponent,
  DsResultCardComponent,
  DsReviewFlagComponent,
  DsScoreVisualizationComponent,
  DsSelectDirective,
  DsTableComponent,
} from '../../ui';

export type ReferenceScreen =
  | 'login'
  | 'dashboard'
  | 'instructions'
  | 'question'
  | 'timed'
  | 'mobile'
  | 'results'
  | 'report'
  | 'history'
  | 'settings';

@Component({
  selector: 'app-example-screens-page',
  imports: [
    RouterLink,
    DsAlertComponent,
    DsAnswerOptionComponent,
    DsAssessmentHistoryComponent,
    DsAssessmentInstructionsComponent,
    DsAssessmentProgressComponent,
    DsAssessmentTimerComponent,
    DsBadgeComponent,
    DsButtonDirective,
    DsCardComponent,
    DsCheckboxDirective,
    DsFieldComponent,
    DsInputDirective,
    DsQuestionCardComponent,
    DsQuestionNavigatorComponent,
    DsResultCardComponent,
    DsReviewFlagComponent,
    DsScoreVisualizationComponent,
    DsSelectDirective,
    DsTableComponent,
  ],
  templateUrl: './example-screens-page.html',
  styleUrl: './example-screens-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExampleScreensPage implements OnDestroy {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  protected readonly active = signal<ReferenceScreen>('login');
  protected readonly flagged = signal(false);
  protected readonly screens: Array<{ id: ReferenceScreen; label: string; group: string }> = [
    { id: 'login', label: 'Login', group: 'Account' },
    { id: 'dashboard', label: 'Dashboard', group: 'Workspace' },
    { id: 'instructions', label: 'Instructions', group: 'Assessment' },
    { id: 'question', label: 'Question', group: 'Assessment' },
    { id: 'timed', label: 'Timed assessment', group: 'Assessment' },
    { id: 'mobile', label: 'Mobile assessment', group: 'Assessment' },
    { id: 'results', label: 'Results', group: 'Results' },
    { id: 'report', label: 'Detailed report', group: 'Results' },
    { id: 'history', label: 'History', group: 'Account' },
    { id: 'settings', label: 'Account settings', group: 'Account' },
  ];
  protected readonly history: DsAssessmentHistoryItem[] = [
    {
      id: '1',
      title: 'IQLabTest Core Assessment',
      date: '18 July 2026',
      status: 'Complete',
      score: '118',
    },
    {
      id: '2',
      title: 'Pattern Reasoning Practice',
      date: '2 July 2026',
      status: 'Complete',
      score: '82%',
    },
    {
      id: '3',
      title: 'IQLabTest Core Assessment',
      date: '14 June 2026',
      status: 'Archived',
      score: '115',
    },
  ];

  constructor() {
    this.title.setTitle('Reference Screens | IQLabTest Design System');
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
  }

  ngOnDestroy(): void {
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
  }
}
